export default {"src":"/evde-internet/_next/static/media/edit.6759fe59.svg","height":20,"width":19};